module.exports = __webpack_public_path__ + "ET_Achievers_2025-a03e9ae8.webp";